"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var utils_1 = require("../../utils");
var styles_1 = __importDefault(require("./styles"));
exports.Text = react_1.default.memo(function (_a) {
    var children = _a.children, _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.component, component = _c === void 0 ? 'span' : _c, _d = _a.weight, weight = _d === void 0 ? 'regular' : _d, _e = _a.type, type = _e === void 0 ? 'text' : _e, _f = _a.className, className = _f === void 0 ? '' : _f, displayNewLineBreaks = _a.displayNewLineBreaks, _g = _a.muted, muted = _g === void 0 ? false : _g, rest = __rest(_a, ["children", "size", "component", "weight", "type", "className", "displayNewLineBreaks", "muted"]);
    var classes = (0, styles_1.default)({
        displayNewLineBreaks: displayNewLineBreaks,
        muted: muted,
    });
    var textClassName = (0, react_1.useMemo)(function () { return [classes.root, className].join(' '); }, [
        className,
        classes.root,
    ]);
    return ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ fontSize: utils_1.textSizeMap[type][size], fontWeight: utils_1.textWeightMap[weight], component: component, className: textClassName }, rest, { children: children })));
});
exports.Text.displayName = 'Text';
